import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { animateScroll as scroll } from 'react-scroll';
import cx from 'classnames';
import * as selectors from 'selectors';
import styles from './arrows.css';

const pageStyles = {
  Works: 'fillRed',
  Home: 'fillRed',
  Agency: 'fillRed',
  Reels: 'fillRedImportant',
  NotFound: 'fillWhite',
};

const pageColors = {
  Works: '#df1f3e',
  Home: '#df1f3e',
  Agency: '#df1f3e',
  Reels: '#df1f3e',
  NotFound: '#ffffff',
};

const Arrows = ({
  page, menuOpen, color, id, colors,
}) => {
  const logoColor = menuOpen
    ? colors.logoArrows
    : page === 'Works' ? color : pageColors[page];
  return (
    <button
      id={id}
      className={cx(styles.arrowsButton, !menuOpen && styles[pageStyles[page]])}
      onClick={() =>
        scroll.scrollToTop({
          containerId: 'wrapper',
          duration: 300,
          smooth: 'easeInOutQuint',
        })}
      title="Scroll to the top"
      menuOpen={menuOpen}
      colors={colors}
    >
      <svg
        className={styles.icon}
        fill={logoColor}
        viewBox="0 0 63.3 32.7"
        width="54"
        height="35"
      >
        <path d="M12.1 13.6l-7 7.3L0 15.8 15.8 0l15.9 15.8-5.2 5.2-7-7.4v18.6h-7.4V13.6" />
        <path d="M43.8 13.6l-7 7.3-5.1-5.1L47.5 0l15.8 15.8-5.1 5.2-7-7.4v18.6h-7.4V13.6" />
      </svg>
    </button>
  );
};

const mapStateToProps = state => ({
  colors: selectors.getMenuLogoColors(state),
});

export default connect(mapStateToProps)(Arrows);



// WEBPACK FOOTER //
// ./src/components/modules/Header/Arrows.js